export const REQUEST_STATUS_VALUE_IDLE = 0b0001;
export const REQUEST_STATUS_VALUE_FETCHING = 0b0010;
export const REQUEST_STATUS_VALUE_SUCCESS = 0b0100;
export const REQUEST_STATUS_VALUE_ERROR = 0b1000;
